import { useState } from 'react';
import type { StrokeLocation } from '../../selection/stroke';
import { applyStroke, type FillContents } from '../../state/actions';
import { Modal, NumberInput, Select, SliderRow } from '../components/controls';
import { SOLID_CONTENTS } from './fillContents';

const LOCATIONS: { value: StrokeLocation; label: string }[] = [
  { value: 'inside', label: 'Inside' },
  { value: 'center', label: 'Center' },
  { value: 'outside', label: 'Outside' },
];

export function StrokeDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [thickness, setThickness] = useState(3);
  const [location, setLocation] = useState<StrokeLocation>('inside');
  const [contents, setContents] = useState<FillContents>('foreground');
  const [opacity, setOpacity] = useState(100);

  const apply = () => {
    applyStroke({ thickness, location, contents, opacity: opacity / 100 });
    onClose();
  };

  return (
    <Modal
      open={open}
      title="Stroke"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="button button--primary" onClick={apply}>
            Stroke
          </button>
        </>
      }
    >
      <p className="dialog__note">Paints a band along the edge of the selection.</p>
      <div className="field">
        <span className="field__label" style={{ width: 66 }}>
          Width
        </span>
        <NumberInput value={thickness} min={1} max={250} onChange={setThickness} width={70} />
        <span className="field__label">px</span>
      </div>
      <div className="field">
        <span className="field__label" style={{ width: 66 }}>
          Location
        </span>
        <Select value={location} onChange={setLocation} options={LOCATIONS} />
      </div>
      <div className="field">
        <span className="field__label" style={{ width: 66 }}>
          Color
        </span>
        <Select
          value={contents}
          onChange={setContents}
          options={SOLID_CONTENTS.filter((item) => item.value !== 'transparent')}
        />
      </div>
      <SliderRow label="Opacity" value={opacity} min={0} max={100} onChange={setOpacity} />
    </Modal>
  );
}
